import lod_ from "lodash";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	disableRouting: false,
	changeRoute: false,
	config: {
		maxFileSizes: {
			default: 20 // Default: 20MB
		}
	}
};

export const error = initialState;

const slice = createSlice({
	name: "application",
	initialState,
	reducers: {
		setDisableRouting: (state, action) => {
			state.disableRouting = true;
		},
		setEnableRouting: (state, action) => {
			state.disableRouting = false;
		},
		changeRouteHandle: (state, action) => {
			state.changeRoute = action.payload;
		},
		setConfig: (state, action) => {
			state.config = { ...state.config, ...action.payload };
		}
	}
});

export const isRoutingDisabled = state => state.application.disableRouting;
export const selectConfig = state => state.application?.config;
export const selectMaxFileSizes = state => state.application?.config?.maxFileSizes;

/**
 * Get maximum file size by type
 * @param {object} state - Redux state
 * @param {string} type - File type (e.g., 'document', 'image', 'video')
 * @returns {number} Maximum file size in bytes
 */
export const selectMaxFileSizeByType = (state, type) => {
	const maxFileSizes = state.application?.config?.maxFileSizes;

	if (lod_.isNil(maxFileSizes)) {
		return {
			mo: 20,
			bytes: 20 * 1024 * 1024
		};
	}

	const defaultMO = maxFileSizes[type] ?? maxFileSizes.default ?? 20;
	return {
		mo: defaultMO,
		bytes: defaultMO * 1024 * 1024
	};
};

export const { setDisableRouting, setEnableRouting, changeRouteHandle, setConfig } = slice.actions;

export default slice.reducer;
